import React from "react"
import Icon from "react-icons-kit"
import { chevronLeft, chevronRight, filter } from "react-icons-kit/feather"
import Sticky from 'react-stickynode'
import theme from "../../../config/theme"
import Button from "../../BaseElements/Button"
import SelectInput from "../../elements/Form/SelectInput"


const GridHead = (props) => {
    const sortOptions = props.view === "singles" || props.view === "singles-search" ?
      [
        { value: 'new', label: 'Cele mai noi' },
        {value: 'stocked', label: 'Ultimele intrate in stoc'},
        { value: 'date_desc', label: 'Data Lansarii descrescator'},
        { value: 'date_asc', label: 'Data Lansarii crescator'},
        { value: 'alphabetic', label: 'Alfabetic' },
        { value: 'price_asc', label: 'Pret crescator'},
        { value: 'price_desc', label: 'Pret descrescator'},
        { value: 'level_asc', label: 'Nivel crescator' },
        { value: 'level_desc', label: 'Nivel descrescator' },

      ]
    : [
        {value: 'new', label: 'Ultimele adaugate'},
        {value: 'stocked', label: 'Ultimele intrate in stoc'},
        {value: 'alphabetic', label: 'Alfabetic'},
        {value: 'popular', label: 'Cele mai populare'},
        {value: 'price_asc', label: 'Pret crescator'},
        {value: 'price_desc', label: 'Pret descrescator'},
        {value: 'discount', label: 'Discount descrescator'}
    ]

    return (
        <div className="grid-head-wrapper">
            <style jsx>{`
                .category-image {
                    width: 100%;
                    height: 120px;
                    display: block;
                    background-size: 100%;
                    background-position: bottom;
                    // background-image: url('${process.env.imageStorage}/category_image_default_${props.category ? props.category.image : ''}.jpg');
                    display: flex;
                    align-items: flex-end;
                }

                .category-label {

                    color: ${theme.colors.base.white};
                    background-color: ${theme.colors.base.base};
                    font-weight: 700;
                    font-size: 1rem;
                    text-transform: uppercase;
                    padding: 10px;
                }

                .search-image {
                    width: 100%;
                    height: 120px;
                    display: block;
                    background-size: 100%;
                    background-position: bottom;
                    // background-image: url('/img/search-header.jpeg');
                    display: flex;
                    align-items: flex-end;
                }

                .search-image .search-label {
                    background-color: transparent;
                    font-size: 32px;

                }

                .search-label {

                    color: ${theme.colors.base.white};
                    background-color: ${theme.colors.base.base};
                    font-weight: 700;
                    font-size: 1em
                    text-transform: uppercase;
                    padding: 10px;
                }

                .category-image .category-label {
                    background-color: transparent;
                    font-size: 42px;
                    margin-left: 20px;
                }

                .grid-head-wrapper {
                    width: 100%;
                    background-color: ${theme.colors.base.white};
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    padding: 0;

                    border-radius: 5px;
                }

                .sorting {
                    width: 100%;
                    flex-grow: 1;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                }
                .description {
                    padding: 10px;
                    padding-bottom: 0;
                }

                .controls {
                    display: flex;
                    background-color: white;
                    padding-bottom: 3px;
                    border-bottom: 1px solid #dddddd;
                }

                .min-width-button {
                    min-width: 42px;
                }

                @media only screen and (max-width: ${theme.responsive.m}px) {
                    .grid-head-wrapper {
                        margin: 0;
                        border-radius: 0px;
                    }
                }

            `}</style>

        <Sticky enabled={true} top=".header-container" innerZ={100}>
            <div className="controls">
                <Button onClick={props.onFilterToggle} padding={false} shadow={false} type="transparent" color="dark" width={48}>
                    <div className="hide-lt-m">
                        {props.showFilter ?
                            <Icon size={18} icon={chevronLeft}/> :
                            <Icon size={18} icon={chevronRight}/>}
                        Filtre
                    </div>
                    <div className="hide-gt-m min-width-button">
                        <Icon size={18} icon={filter}/>
                    </div>

                </Button>

                <div className="sorting">
                    <SelectInput options={sortOptions}
                        instanceId="listing-sort-select"
                        shadow={false}
                        value={sortOptions.find(opt => opt.value === props.sort)}
                        onChange={(evt) => {
                            props.onSortChange(evt.value);
                        }}
                    />
                </div>
            </div>
        </Sticky>
        </div>
    )
}

export default GridHead;
